/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Draft_Accept_Body_FirstInputs */

const en_us2_draft_accept_body_first = /** @type {(inputs: Draft_Accept_Body_FirstInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The plan starts today, at week 1.`)
};

const pt_br2_draft_accept_body_first = /** @type {(inputs: Draft_Accept_Body_FirstInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`O plano começa hoje, na semana 1.`)
};

const es_419_draft_accept_body_first = /** @type {(inputs: Draft_Accept_Body_FirstInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`El plan empieza hoy, en la semana 1.`)
};

const pt_pt2_draft_accept_body_first = /** @type {(inputs: Draft_Accept_Body_FirstInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`O plano começa hoje, na semana 1.`)
};

const fr_fr2_draft_accept_body_first = /** @type {(inputs: Draft_Accept_Body_FirstInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Le programme commence aujourd'hui, en semaine 1.`)
};

const de_de2_draft_accept_body_first = /** @type {(inputs: Draft_Accept_Body_FirstInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Der Plan beginnt heute, in Woche 1.`)
};

const it_it2_draft_accept_body_first = /** @type {(inputs: Draft_Accept_Body_FirstInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`La scheda inizia oggi, dalla settimana 1.`)
};

/**
* | output |
* | --- |
* | "The plan starts today, at week 1." |
*
* @param {Draft_Accept_Body_FirstInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const draft_accept_body_first = /** @type {((inputs?: Draft_Accept_Body_FirstInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Draft_Accept_Body_FirstInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_draft_accept_body_first(inputs)
	if (locale === "es-419") return es_419_draft_accept_body_first(inputs)
	if (locale === "pt-PT") return pt_pt2_draft_accept_body_first(inputs)
	if (locale === "fr-FR") return fr_fr2_draft_accept_body_first(inputs)
	if (locale === "de-DE") return de_de2_draft_accept_body_first(inputs)
	if (locale === "it-IT") return it_it2_draft_accept_body_first(inputs)
	return en_us2_draft_accept_body_first(inputs)
});
export { draft_accept_body_first as "draft.accept_body_first" }